import { FormGroup } from '@angular/forms';
import _ from 'lodash';
import { flatten } from 'flat';

export abstract class ReactiveFormBase {
  abstract form?: FormGroup;
  abstract formErrors?: any;
  abstract validationMessages?: any;
  abstract buildForm(): void;

  onValueChanged(): void {
    const form = this.form;

    if (!form) {
      return;
    }

    const flattenedFormErrors = flatten(this.formErrors);

    for (const key of _.keys(flattenedFormErrors)) {
      this.formErrors[key] = '';

      const control = form.get(key);

      if (control && control.dirty && !control.valid) {
        const messages = _.get(this.validationMessages, key);

        for (const error in control.errors) {
          if (control.errors.hasOwnProperty(error)) {
            this.formErrors[key] += messages[error] + ' ';
          }
        }
      }
    }
  }
}
